// extracted by mini-css-extract-plugin
module.exports = {"errorText":"confirmModalBlocks_errorText__XrhQs","confirmationBlock":"confirmModalBlocks_confirmationBlock__UFb5y","expectedValue":"confirmModalBlocks_expectedValue__Seuw9"};